<div class="inbox-page">

  <app-page-header
    title="Support Inbox"
    [subtitle]="inboxSubtitle"
    [showBackButton]="true"
    backRoute="/userhome"
    backLabel="Back to Home">
    <div class="inbox-header__actions">
      <button class="btn-primary btn-sm inbox-new-btn"
        type="button"
        *ngIf="canCreateTicket"
        (click)="router.navigate(['/help'])">
        <mat-icon>add</mat-icon>
        New Support Request
      </button>
      <button class="btn-secondary btn-sm"
        type="button"
        *ngIf="canViewAnalytics"
        (click)="router.navigate(['/help/analytics'])">
        Analytics
      </button>
      <button class="btn-secondary btn-sm"
        type="button"
        *ngIf="canManageSettings"
        (click)="router.navigate(['/help/settings'])">
        Settings
      </button>
    </div>
  </app-page-header>

  <!-- Stats -->
  <div class="inbox-header">
    <div class="inbox-stats">
      <div class="inbox-stat inbox-stat--open">
        <span class="inbox-stat__count">
          {{ openCount }}
        </span>
        <span class="inbox-stat__label">Open</span>
      </div>
      <div class="inbox-stat inbox-stat--progress">
        <span class="inbox-stat__count">
          {{ inProgressCount }}
        </span>
        <span class="inbox-stat__label">
          In Progress
        </span>
      </div>
      <div class="inbox-stat inbox-stat--resolved">
        <span class="inbox-stat__count">
          {{ resolvedCount }}
        </span>
        <span class="inbox-stat__label">
          Resolved
        </span>
      </div>
    </div>
  </div>

  <!-- Filters -->
  <div class="inbox-filters">
    <mat-form-field appearance="outline" class="support-select" subscriptSizing="dynamic">
      <mat-label>Status</mat-label>
      <mat-select
        [(ngModel)]="filterStatus"
        name="filterStatus"
        (selectionChange)="onFilterChange()"
        panelClass="owner-station-filter-panel">
        <mat-option *ngFor="let s of statusOptions" [value]="s.value">
          {{ s.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="support-select" subscriptSizing="dynamic">
      <mat-label>Category</mat-label>
      <mat-select
        [(ngModel)]="filterCategory"
        name="filterCategory"
        (selectionChange)="onFilterChange()"
        panelClass="owner-station-filter-panel">
        <mat-option value="">All Categories</mat-option>
        <mat-option *ngFor="let cat of categories" [value]="cat.value">
          {{ cat.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="support-select" subscriptSizing="dynamic">
      <mat-label>Station</mat-label>
      <mat-select
        [(ngModel)]="filterStationId"
        name="filterStationId"
        (selectionChange)="onFilterChange()"
        panelClass="owner-station-filter-panel">
        <mat-option value="">All Stations</mat-option>
        <mat-option *ngFor="let s of stationOptions" [value]="'' + s.id">
          {{ s.name }}<ng-container *ngIf="s.call_sign"> ({{ s.call_sign }})</ng-container>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="support-select"
      subscriptSizing="dynamic"
      *ngIf="isAdmin">
      <mat-label>Source</mat-label>
      <mat-select
        [(ngModel)]="filterSource"
        name="filterSource"
        (selectionChange)="onFilterChange()"
        panelClass="owner-station-filter-panel">
        <mat-option *ngFor="let s of sourceOptions" [value]="s.value">
          {{ s.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button class="btn-secondary btn-sm"
      type="button"
      (click)="clearFilters()"
      *ngIf="hasActiveFilters">
      Clear Filters
    </button>
  </div>

  <div class="inbox-loading" *ngIf="loading">
    <app-data-loader [show]="true"
      message="Loading tickets..."
      size="medium" />
  </div>

  <!-- Tickets table -->
  <div class="inbox-table-wrap" *ngIf="!loading">
    <table class="inbox-table" *ngIf="tickets.length > 0">
      <thead>
        <tr>
          <th>Ticket #</th>
          <th>Subject</th>
          <th>From</th>
          <th>Category</th>
          <th>Status</th>
          <th>Priority</th>
          <th>Created</th>
          <th>Replies</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of inboxRows">
        <tr *ngIf="row.kind === 'group'" class="inbox-group-row">
          <td colspan="8">{{ row.label }}</td>
        </tr>
        <tr *ngIf="row.kind === 'ticket'"
          class="inbox-table__row"
          (click)="openTicket(row.ticket)">
          <td class="ticket-num-cell">
            {{ row.ticket.ticket_number }}
          </td>
          <td class="ticket-subject-cell">
            {{ row.ticket.subject }}
          </td>
          <td>
            <span
              class="source-flag"
              [class.source-flag--advertiser]="ticketSource(row.ticket) === 'advertiser'"
              [class.source-flag--station]="ticketSource(row.ticket) === 'station'">
              {{ ticketSourceLabel(row.ticket) }}
            </span>
            <div>
              {{ row.ticket.firstname }}
              {{ row.ticket.lastname }}
            </div>
            <small class="text-muted">
              {{ row.ticket.user_email }}
            </small>
          </td>
          <td>
            {{ getCategoryLabel(row.ticket.category) }}
          </td>
          <td>
            <span [class]="'ticket-status ticket-status--' + row.ticket.status">
              {{ getStatusLabel(row.ticket.status) }}
            </span>
          </td>
          <td>
            <span [class]="'ticket-priority ticket-priority--' + row.ticket.priority">
              {{ row.ticket.priority }}
            </span>
          </td>
          <td>
            {{ row.ticket.created_at | date:'MMM d, y' }}
          </td>
          <td>{{ row.ticket.reply_count || 0 }}</td>
        </tr>
        </ng-container>
      </tbody>
    </table>

    <!-- Empty state -->
    <div class="inbox-empty"
      *ngIf="tickets.length === 0 && !loading">
      <p>{{ isAdmin
        ? 'No tickets found matching your filters.'
        : 'No incoming advertiser tickets match your filters.' }}</p>
      <p class="inbox-empty__hint" *ngIf="!isAdmin">
        Tickets you raise with RAD admin are under
        <button type="button" class="inbox-empty__link"
          (click)="router.navigate(['/help'])">
          Raise a Ticket
        </button>.
      </p>
    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination"
    *ngIf="totalPages > 1 && !loading"
    role="navigation">

    <button type="button"
      class="pagination-btn"
      [class.disabled]="currentPage === 1"
      [disabled]="currentPage === 1"
      (click)="goToPage(currentPage - 1)">
      Previous
    </button>

    <div class="pagination-numbers">
      <button type="button"
        *ngFor="let page of getPaginationPages()"
        class="pagination-number"
        [class.active]="page === currentPage"
        (click)="goToPage(page)">
        {{ page }}
      </button>
    </div>

    <button type="button"
      class="pagination-btn"
      [class.disabled]="currentPage === totalPages"
      [disabled]="currentPage === totalPages"
      (click)="goToPage(currentPage + 1)">
      Next
    </button>
  </div>
</div>
